import React from 'react';
import { GenericButton } from '../../../../../ui-components/Button/GenericButton';

interface BestOnlyToggleProps {
  bestOnly: boolean;
  onToggle: () => void;
}

/**
 * Narrows every surface (topology, table and metrics) to best paths only.
 *
 * Split out of the old `ControlButtons` pair because the single-row toolbar places this beside
 * the direction tabs while Refresh sits next to the filter input — two slots, so two components
 * rather than one component carrying layout props.
 *
 * `active` is the highlighted variant and `secondary` the plain one, so the filter being ON maps
 * to `active` — the pair was reversed, which made the button look pressed while showing every
 * route and unpressed while narrowed to best paths.
 */
export const BestOnlyToggle: React.FC<BestOnlyToggleProps> = ({ bestOnly, onToggle }) => (
  <GenericButton
    variant={bestOnly ? 'active' : 'secondary'}
    shape="filled"
    size="sm"
    label="Best only"
    aria-pressed={bestOnly}
    onClick={onToggle}
  />
);
